import forEach from 'lodash/forEach';
import has from 'lodash/has';

import rxEventHub, { RxEvent } from '../services/events/rx';
import socketEventHub, { ReceiveSocketEvent } from '../services/events/sockets';
import { PASS_STATUS_OPTIONS } from './constants/filterOptions';

const vaults = {};
let isStarted = false;

function _reset() {
  forEach(vaults, (passVault) => passVault.resetFilters());
}

function _updatePass(pass) {
  forEach(vaults, (passVault) => {
    if (pass.status === PASS_STATUS_OPTIONS.CHECKED_OUT.value || pass.status === PASS_STATUS_OPTIONS.REJECTED.value) {
      const existingPass = passVault.findPass(pass.id);
      if (existingPass) {
        if (pass.hostNotes === undefined && existingPass.hostNotes) {
          pass['hostNotes'] = existingPass.hostNotes;
        }
        if (pass.adminNotes === undefined && existingPass.adminNotes) {
          pass['adminNotes'] = existingPass.adminNotes;
        }

        passVault.updatePass(existingPass.id, pass);
      } else {
        passVault.addPass(pass);
      }
    } else {
      passVault.removePass(pass.id);
    }
  });
}

function _handlePassDeleted(pass) {
  forEach(vaults, (passVault) => {
    passVault.removePass(pass.id);
  });
}

function _handleAuthChangeWebPush() {
  _reset();
}

export default {
  register: (vault) => {
    const vaultType = vault.getType();
    if (!has(vaults, vaultType)) {
      vaults[vaultType] = vault;
    }
  },

  start: () => {
    if (!isStarted) {
      socketEventHub.on(ReceiveSocketEvent.PASS, ({ data: pass }) => _updatePass(pass), false);
      socketEventHub.on(ReceiveSocketEvent.USER_PERMISSIONS_CHANGED, _handleAuthChangeWebPush);
      socketEventHub.on(ReceiveSocketEvent.PASS_DELETED, ({ data }) => _handlePassDeleted(data));

      isStarted = true;

      rxEventHub.on(RxEvent.PASS_UPDATED, ({ data: { pass } }) => _updatePass(pass));
      rxEventHub.on(RxEvent.LOGOUT, () => _reset());
      rxEventHub.on(RxEvent.SITE_DELETED, () => _reset());
    }
  },

  reset: () => {
    _reset();
  },
};
